module.exports = __webpack_public_path__ + "static/media/payment-methods-fr.728999c2.png";